import { Box, Container, Stack, Typography } from "@mui/material";
import React, { FC } from "react";
import { SalifySocialIcon } from "src/lib/components/ui/icon/social-icon";
import { SalifyLinkV2 } from "src/lib/components/ui/link/link";
import { SocialGroupInterface } from "src/lib/utils/interfaces";
interface NovaPressHeaderTopBarProps {
  name: string | undefined;
  topBarInfoText: string | undefined;
  socialGroup: Array<SocialGroupInterface> | undefined;
  socialSpacing?: number;
  topBarBgColor?: string;
  showSearch?: boolean;
  searchPlaceholder?: string;
  nameStyle?: {
    fontSize?: string;
    fontWeight?: number;
    color?: string;
    fontFamily?: string;
  };
}

export const NovaPressHeaderTopBar: FC<NovaPressHeaderTopBarProps> = ({
  name,
  topBarInfoText,
  socialGroup,
  socialSpacing = 1,
  topBarBgColor,
  showSearch = false,
  searchPlaceholder = "Nhập tên sản phẩm cần tìm",
  nameStyle,
}) => {
  return (
    <Box
      py={{ mobile: 0.75, laptop: 1 }}
      bgcolor={topBarBgColor || "primary.main"}
      color="primary.contrastText"
      display="block"
    >
      {(name || topBarInfoText || !!socialGroup?.length) && (
        <Container
          disableGutters
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: { mobile: "wrap", laptop: "nowrap" },
            gap: { mobile: 0.5, laptop: 0 },
            px: { mobile: 1.5, laptop: 0 },
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            divider={
              name && topBarInfoText ? (
                <Box
                  mx={{ mobile: 0.75, laptop: 1 }}
                  width="1px"
                  height={{ mobile: 12, laptop: 16 }}
                  sx={{ backgroundColor: "primary.contrastText" }}
                />
              ) : null
            }
          >
            {name && (
              <Typography
                fontWeight={nameStyle?.fontWeight || 600}
                sx={{
                  fontSize: nameStyle?.fontSize || { mobile: "0.875rem", laptop: "inherit" },
                  color: nameStyle?.color || "text.black",
                  fontFamily: nameStyle?.fontFamily || "inherit",
                }}
              >
                {name}
              </Typography>
            )}

            {topBarInfoText && (
              <Typography
                component="span"
                sx={{
                  display: "inline-block",
                  color: "text.primary",
                  bgcolor: "rgba(255,255,255,0.94)",
                  px: 1,
                  py: 0.25,
                  borderRadius: 1,
                  fontSize: { mobile: "0.75rem", laptop: "inherit" },
                }}
              >
                {topBarInfoText}
              </Typography>
            )}
          </Stack>

          <Stack direction="row" spacing={socialSpacing} alignItems="center" sx={{ ml: "auto" }}>
            {!!socialGroup?.length &&
              socialGroup.map((item, index) => {
                if (!item.url) return null;

                return (
                  <SalifyLinkV2
                    href={item.url}
                    key={index}
                    aria-label={item.type ? `${item.type} profile` : "Social link"}
                  >
                    <SalifySocialIcon type={item.type} color="primary.contrastText" />
                  </SalifyLinkV2>
                );
              })}
          </Stack>
        </Container>
      )}
    </Box>
  );
};
